import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

import { BRAND_COLOR, SURFACE_OVERLAY } from "../utils/colors";

/**
 * Loading screen shown while a page or tab fetches its initial data.
 *
 * - `fullScreen` covers the whole widget viewport (route-level loads);
 *   without it the loader renders inline (tab-level loads).
 * - `message` describes what is being loaded.
 */
const PageLoader = ({ fullScreen = false, message = "Loading..." }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2.5,
      ...(fullScreen
        ? {
            position: "fixed",
            inset: 0,
            // translucent so the host page shows through while loading
            bgcolor: SURFACE_OVERLAY,
            backdropFilter: "blur(2px)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }
        : {
            width: "100%",
            py: 12,
          }),
    }}
  >
    <CircularProgress size={30} thickness={4.2} sx={{ color: BRAND_COLOR }} />
    <Typography
      sx={{
        color: "text.secondary",
        fontSize: 14,
        letterSpacing: "0.4px",
      }}
    >
      {message}
    </Typography>
  </Box>
);

export default PageLoader;
